import { cosmoAPI, cosmoWEB } from "@/core/Api/cosmoAxiosInstance";

export default {
  getOrganizations(page = 1) {
    return cosmoAPI.get("/organization/", {
      params: {
        page,
      },
    });
  },
  getSSOReady() {
    return cosmoWEB.get("/oidc/aad-ready/");
  },
  getWalletOrganization(organizationId) {
    return cosmoAPI.get(`/wallet/organization/${organizationId}/`);
  },
  getOrganizationValidationSchema(organizationId) {
    return cosmoAPI.get(`/organization/${organizationId}/validation-schema/`);
  },
  patchOrganizationValidationSchema({
    organizationId,
    validationSchemaId,
    payload,
  }) {
    return cosmoAPI.patch(
      `/organization/${organizationId}/validation-schema/${validationSchemaId}/`,
      payload
    );
  },
  getOrganizationDocumentTemplates(organizationId) {
    return cosmoAPI.get(`/organization/${organizationId}/docx-template/`);
  },
  postOrganizationDocumentControl(organizationId, folderId, payload) {
    return cosmoAPI.post(
      `organization/${organizationId}/folder/${folderId}/control/`,
      payload
    );
  },
  postOrganizationOfferTemplates({ organizationId, payload }) {
    return cosmoAPI.post(
      `organization/${organizationId}/offer-templates/`,
      payload
    );
  },
  postOrganizationOfferTemplatesFiles({
    organizationId,
    payload,
    offerTemplateId,
  }) {
    return cosmoAPI.post(
      `organization/${organizationId}/offer-templates/${offerTemplateId}/files/`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  deleteOrganizationOfferTemplatesFiles({
    organizationId,
    offerTemplateId,
    offerFileId,
  }) {
    return cosmoAPI.delete(
      `organization/${organizationId}/offer-templates/${offerTemplateId}/files/${offerFileId}/`
    );
  },
  patchOrganizationOfferTemplatesFiles({
    organizationId,
    payload,
    offerTemplateId,
    offerFileId,
  }) {
    return cosmoAPI.patch(
      `organization/${organizationId}/offer-templates/${offerTemplateId}/files/${offerFileId}/`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  patchOrganizationOfferTemplates({
    organizationId,
    payload,
    offerTemplateId,
  }) {
    return cosmoAPI.patch(
      `organization/${organizationId}/offer-templates/${offerTemplateId}/`,
      payload
    );
  },
  postOrganizationWizideeVerification({ organizationId }) {
    return cosmoAPI.post(
      `organization/${organizationId}/test-wizidee-credentials/`
    );
  },
  postOrganizationYousignVerification({ organizationId }) {
    return cosmoAPI.post(`organization/${organizationId}/test-yousign-config/`);
  },
  postOrganizationDocumentControlRun(
    organizationId,
    folderId,
    documentControlId
  ) {
    return cosmoAPI.post(
      `organization/${organizationId}/folder/${folderId}/control/${documentControlId}/run/`
    );
  },
  postOrganizationDocumentGenerate({ organizationId, folderId, payload }) {
    return cosmoAPI.post(
      `/organization/${organizationId}/folder/${folderId}/generate-document/`,
      payload
    );
  },
  postOrganization({ name, avatar }) {
    let payload = new FormData();
    payload.append("name", name);
    if (avatar) {
      payload.append("avatar", avatar);
    }
    return cosmoAPI.post("/organization/", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  postOrganizationToGED({ organizationId, folderId }) {
    return cosmoAPI.post(
      `/organization/${organizationId}/folder/${folderId}/files/to_ged/`
    );
  },
  getOrganization(organizationId) {
    return cosmoAPI.get(`/organization/${organizationId}/`);
  },
  patchOrganization(organizationId, data) {
    let payload = new FormData();
    if (data.avatar || data.logo) {
      data.avatar
        ? payload.append("avatar", data.avatar)
        : payload.append("logo", data.logo);
      return cosmoAPI.patch(`/organization/${organizationId}/`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }
    return cosmoAPI.patch(`/organization/${organizationId}/`, data);
  },
  getOrganizationCollaborators(organizationId, page, email) {
    const params = { page };
    if (email) params.email = email;
    return cosmoAPI.get(`/organization/${organizationId}/collaborator/`, {
      params,
    });
  },
  deleteOrganizationCollaborator({ organizationId, collaboratorId }) {
    return cosmoAPI.delete(
      `/organization/${organizationId}/collaborator/${collaboratorId}/`
    );
  },
  getOrganizationDocxTemplate({ organizationId, filters }) {
    return cosmoAPI.get(`/organization/${organizationId}/docx-template/`, {
      params: {
        ...filters,
      },
    });
  },
  getOrganizationOfferTemplate({ organizationId, filters }) {
    return cosmoAPI.get(`/organization/${organizationId}/offer-templates/`, {
      params: {
        ...filters,
      },
    });
  },
  getOrganizationOfferTemplateDetail({ organizationId, offerTemplateId }) {
    return cosmoAPI.get(
      `/organization/${organizationId}/offer-templates/${offerTemplateId}/`
    );
  },
  postOrganizationDocxTemplate({ organizationId, name, file }) {
    let payload = new FormData();
    payload.append("name", name);
    payload.append("file", file);
    return cosmoAPI.post(
      `/organization/${organizationId}/docx-template/`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  patchOrganizationDocxTemplate({
    organizationId,
    docxTemplateId,
    name,
    file,
  }) {
    let payload = new FormData();
    payload.append("name", name);
    payload.append("file", file);
    return cosmoAPI.patch(
      `/organization/${organizationId}/docx-template/${docxTemplateId}/`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  deleteOrganizationDocxTemplate({ organizationId, docxTemplateId }) {
    return cosmoAPI.delete(
      `/organization/${organizationId}/docx-template/${docxTemplateId}/`
    );
  },
  getOrganizationNotifications({ organizationId, params }) {
    return cosmoAPI.get(`/organization/${organizationId}/notifications/`, {
      params: params,
    });
  },
  async getNotificationsType() {
    return (await cosmoAPI.get("/notification/types/")).data;
  },
  getFoldersToReview({ params }) {
    return cosmoAPI.get("/folders-to-review/", {
      params: params,
    });
  },
  patchCollaboratorFunction({ organizationId, collaboratorId, role }) {
    return cosmoAPI.patch(
      `/organization/${organizationId}/collaborator/${collaboratorId}/`,
      {
        function: role,
      }
    );
  },
};
